<!--
 * @Author: your name
 * @Date: 2020-04-30 16:07:21
 * @LastEditTime: 2020-05-06 18:18:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\src\views\Authority.vue
 -->
<template>
  <div class="autority-content">
    <form method="post">
      <div class="page">
        <div class="login">
          <div class="title">
            软件注册
          </div>
          <table>
            <tr>
              <td>
                申请码：
              </td>
              <td>
                <!--  value="@ViewBag.ApplyCode" -->
                <input
                  type="text"
                  name="applyId"
                  class="input"
                  readonly="readonly"
                  style="color:#999"
                  v-model="ApplyCode"
                />
              </td>
            </tr>
            <tr>
              <td>
                注册码：
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  id="registerCode"
                  name="registerCode"
                  :readonly="readonly"
                  v-model="registerCode"
                />
              </td>
            </tr>
            <tr>
              <td>
                授权码：
              </td>
              <td>
                <input
                  type="text"
                  class="input"
                  id="licenseCode"
                  name="licenseCode"
                  :readonly="readonly"
                  v-model="licenseCode"
                />
              </td>
            </tr>
            <tr>
              <th></th>
              <td>
                <input
                  id="shouquan"
                  @click="submitAuthority"
                  type="button"
                  value="注册"
                  class="btn"
                  v-model="shouquan"
                />
              </td>
            </tr>
            <tr>
              <td
                colspan="2"
                align="center"
                style="height: 42px; color: Red"
                id="message"
              ></td>
            </tr>
          </table>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AUTHORITY from '@/axios/authority/Authority'
export default {
  name: 'Authority',
  data() {
    return {
      int: null,
      ApplyCode: '', //申请码
      registerCode: null,
      licenseCode: null,
      time: 3,
      readonly: false,
      shouquan: '注册',
    }
  },
  mounted() {
    // this.GetRegNo() //获取申请码
    console.log('window.ApplyCode', window.ApplyCode)
    this.ApplyCode =window.ApplyCode
    if(!this.ApplyCode){
      document.querySelector('#message').innerHTML = `无法获取申请码！`
    }
  },
  methods: {
    countDown() {
      let self = this
      this.int = setInterval(function() {
        let time = this.time
        if (this.time > 0) {
          document.querySelector(
            '#message'
          ).innerHTML = `授权成功！将在${time}秒后跳转`
          //     $("#message").text("授权成功！将在" + time + "秒后跳转");
          time = time - 1
        } else {
          window.clearInterval(this.int)
          //根据需要跳转至相应页面
          //self.$router.push("/accountsetting"); //跳转到首页
          // setTimeout(() => {
          //   window.location.reload(); //重新加载页面
          // }, 50);
          // 页面跳转
          var host = location.origin
          window.location.replace(host)
        }
      }, 1000)
    },

    async submitAuthority() {
      let self = this,
        registerCode = this.registerCode,
        licenseCode = this.licenseCode,
        data = { registerCode: registerCode, grantCode: licenseCode }
      if (!this.ApplyCode) {
        return this.$message.error('无法获取申请码，不允许授权！')
      }

      if (
        !licenseCode ||
        !registerCode ||
        registerCode == '' ||
        licenseCode == ''
      ) {
        return (document.querySelector(
          '#message'
        ).innerHTML = `注册码或者授权码为空!`)
      }

      let resultMap = await AUTHORITY.authorityRegister(data)
      if (resultMap.isSuccess == true) {
        this.readonly = true
        this.shouquan = '授权成功！'
        window.gtaAiConfig.IF_AUTHORITY = true
        localStorage.IF_AUTHORITY = 'true'
        this.countDown()
      } else if (resultMap.isSuccess == false) {
        document.querySelector('#message').innerHTML =
          resultMap.ErrorMsg || `授权失败！请输入正确注册码、授权码！`
      } else {
        document.querySelector(
          '#message'
        ).innerHTML = `未知异常，请联系管理员！...`
      }
    },
    // async GetRegNo() {
    //   let self = this
    //   sessionStorage.IF_AUTHORITY = 'false'
    //   AUTHORITY.authorityAbout().then((res) => {
    //     if (res.isSuccess) {
    //       //已授权
    //       this.$router.push('/')
    //       sessionStorage.IF_AUTHORITY = 'true'
    //     } else if (res && res.message) {
    //       self.ApplyCode = res.applyId  
    //     } else {
    //       document.querySelector('#message').innerHTML = `无法获取申请码！`
    //     }
    //   })
    // },
  }, //methods end
}
</script>

<style scoped lang="scss">
.autority-content {
  .login {
    background: none repeat scroll 0 0 #ffffff;
    border: 1px solid #b0d6f4;
    height: 375px;
    left: 50%;
    margin: -188px 0 0 -335px;
    position: absolute;
    top: 50%;
    width: 670px;
  }

  .login .title {
    background: none repeat scroll 0 0 #4da9eb;
    color: #ffffff;
    font: 20px/48px Microsoft YaHei;
    margin-bottom: 70px;
    padding-left: 10px;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
    text-align: left;
    margin: 0 auto;
  }

  .login .input {
    border: 1px solid #95c6f2;
    height: 20px;
    margin-bottom: 5px;
    padding: 4px;
    width: 240px;
  }

  .login input {
    vertical-align: middle;
  }

  .login .btn {
    background-color: #4da9eb;
    border: 0 none;
    border-radius: 3px;
    color: #ffffff;
    cursor: pointer;
    font: 16px Microsoft YaHei;
    height: 43px;
    margin-bottom: 5px;
    width: 250px;
  }
}
</style>
